'use client'

import withSuspense from '@/components/component-factories/with-suspense'
import { createContext, PropsWithChildren, use } from 'react'

const createContextProvider = <T extends any>() => {
  const context = createContext<T | null>(null)

  const Provider = withSuspense(
    ({ children, value }: PropsWithChildren<{ value: T | Promise<T> }>) => {
      const resolvedValue = value instanceof Promise ? use(value) : value
      return (
        <context.Provider value={resolvedValue}>{children}</context.Provider>
      )
    },
  )

  const useContextValue = () => {
    const value = use(context)
    if (!value) {
      throw new Error(
        'useContext must be used within a corresponding ContextProvider',
      )
    }
    return value
  }

  return [Provider, useContextValue] as const
}

export default createContextProvider
